import React, { memo, useCallback, useState } from 'react';
import classNames from 'classnames';
import { useParams } from 'react-router-dom';

import { Avatar } from '../../Avatar';
import { Spinner } from '../../helpers/Spinner';
import Button from '../../helpers/Button';

import style from './style.module.css';

const DirectorsSidebarComponent = ({ data, isLoading, count, onSearch, onSearchClear, onSelect }) => {
  const params = useParams();
  const [searchValue, setSearchValue] = useState('');

  const handleClick = useCallback(
    userId => {
      onSelect(userId);
    },
    [onSelect],
  );

  const handleSearch = useCallback(
    event => {
      setSearchValue(event.target.value);
      onSearch(event);
    },
    [onSearch],
  );

  const handleSearchClear = useCallback(() => {
    setSearchValue('');
    onSearchClear();
  }, [onSearchClear]);

  return (
    <div className={classNames('panel panel-default', style.directorSidebarHost)}>
      <div className="panel-heading">
        <div className="d-flex align-items-center justify-content-space-between">
          <h5 className={style.panelHeading}>Directors</h5>
          <span className="label label-muted font-size-10">{count}</span>
        </div>
      </div>
      <div className="panel-body default">
        <div className={style.searchBar}>
          <input
            className={classNames('form-control input-lg', style.searchInput)}
            onInput={handleSearch}
            placeholder="Search directors..."
            value={searchValue}
          />
          {searchValue && (
            <Button className={classNames('btn-link', style.searchClearButton)} onClick={handleSearchClear}>
              <i className="fa fa-close mr0" />
            </Button>
          )}
        </div>
      </div>
      <div className={style.directorsList}>
        {isLoading && <Spinner />}
        {data?.map(director => {
          const fullName = `${director.get('firstName')} ${director.get('lastName')}`;
          const isActive = String(director.get('id')) === params.id;

          return (
            <button
              key={director.get('id')}
              className={classNames(style.buttonDirector, { [style.active]: isActive })}
              onClick={() => handleClick(director.get('id'))}
              type="button"
            >
              <div className={style.directorAvatar}>
                <Avatar
                  backgroundColor={isActive ? 'var(--primary)' : 'var(--primary-dark)'}
                  color="#fff"
                  name={fullName}
                />
              </div>
              <div className={style.directorInfo}>
                <div className={style.directorName}>{fullName}</div>
                <div className={style.directorMeta}>
                  {director.get('lastName')} Module · {director.get('teamsCount')} teams ·{' '}
                  {director.get('directReportsCount')} reports
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export const DirectorsSidebar = memo(DirectorsSidebarComponent);
